import { userTypes } from "../actionTypes/userTypes";

const INITIAL_STATE = {
    value: 0,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default ( state = INITIAL_STATE, action ) => {
    switch (action.type) {
       case userTypes.SUCCESS:
        return {
            ...state,
            value: action.value
        }
        default: return state;
    }
}